import privacy from "./privacy/index.js";
import deletion from "./account-deletion/index.js";
import oauthRedirect from "./oauth-login/redirect";
import oauthSplash from "./oauth-login/splash";
import oops from "./failed-route/index.js";
import silentRenew from "./silent-renew/index.js";

const deps = [
	privacy,
	oauthRedirect,
	oauthSplash,
	oops, 
	deletion,
	silentRenew
];

export default angular.module("vesl.screens.public", deps).name;
